import React from 'react'
import {Terrace} from "./icons";
import Link from "../utils/link";

const Header = () => {
    const [offCanvas, setOffCanvas] = React.useState(false)
    const [scrolled, setScrolled] = React.useState(false)
    const [sticky, setSticky] = React.useState(false)
    const [direction, setDirection] = React.useState('down')

    let props = {
        onClick: () => setOffCanvas(false),
        activeClassName: 'active',
    }

    const openOffCanvas = () => {
        setOffCanvas(!offCanvas)
    }

    const closeMenu = () => {
        setOffCanvas(false)
    }

    let isScrolling
    let prevScroll = 0

    const onScroll = (e) => {

        let scr, hhScrolled

        const curScroll = window.scrollY || document.scrollTop
        const stickyHeader = document?.querySelector(".sticky-header")
        scr = curScroll > 1
        const dir = curScroll > prevScroll ? "down" : "up"

        if (Math.abs(prevScroll - curScroll) <= 5) return

        if (stickyHeader) {
            if (direction === "down") {
                setSticky(true)
                stickyHeader.classList.add("active")
            } else {
                setSticky(false)
                stickyHeader.classList.remove("active")
            }
        } else {
            setSticky(false)
        }

        prevScroll = curScroll

        requestAnimationFrame(() => {
            setScrolled(scr)
            setDirection(dir)
        })
    }

    const scrollDetect = () => {
        window.clearTimeout(isScrolling)
        isScrolling = setTimeout(onScroll, 0)
    }

    React.useEffect(() => {
        window.addEventListener("scroll", scrollDetect, false)
        return () => {
            window.removeEventListener("scroll", scrollDetect, false)
        }
    }, [])

    let headerClass = "header"
    if (scrolled) headerClass += " header--scrolled"
    if (offCanvas) headerClass += " header--off-canvas"
    if (sticky) headerClass += " header--sticky"
    if (direction === 'down' && scrolled) headerClass += ' header--up'

    return (
        <>
            <header className={headerClass}>
                <div className='header__inner'>
                    <div className='header__button'>
                        <Link className='btn btn--baby-pink' to='https://www.sevenrooms.com/explore/theterrace/reservations/create/search'>Book Now</Link>
                    </div>
                    <div className='header__nav'>
                        <ul>
                            <li><Link to='/events' {...props}>Events</Link></li>
                            <li><Link to='/menu' {...props}>Menu</Link></li>
                            <li><Link to='/the-kiosk' {...props}>Cafe & Kiosk</Link></li>
                        </ul>
                    </div>
                    <div className='header__logo'>
                        <Link to='/'><Terrace /></Link>
                    </div>
                    <nav className='header__nav header__nav--right'>
                        <ul>
                            <li><Link target='_blank' to='https://darlinggroup.com.au/vouchers/'>Vouchers</Link></li>
                            <li><Link to='/contact' {...props}>Contact</Link></li>
                            <li><Link to='https://www.sevenrooms.com/explore/theterrace/reservations/create/search' className='btn btn--garden' {...props}>Book</Link></li>
                        </ul>
                    </nav>
                    <button onClick={() => openOffCanvas()}
                            className={`btn btn--light-maroon ${offCanvas ? 'header__hamburger active' : 'header__hamburger'}`}>
                        {offCanvas ? 'Close' : 'Menu'}
                    </button>
                </div>
            </header>

            <div className={`off-canvas ${offCanvas && 'active'}`}>
                <div className='off-canvas__inner'>
                    <nav className='off-canvas__nav'>
                        <ul>
                            <li><Link to='/menu' {...props}>Menu</Link></li>
                            <li><Link to='/events' {...props}>Events</Link></li>
                            <li><Link to='/menu' {...props}>Menu</Link></li>
                            <li><Link to='/the-kiosk' {...props}>Cafe & Kiosk</Link></li>
                            <li><Link to='https://darlinggroup.com.au/vouchers/' {...props}>Vouchers</Link></li>
                            <li><Link to='/contact' {...props}>Contact</Link></li>
                            <li><Link to='https://www.sevenrooms.com/explore/theterrace/reservations/create/search' {...props}>Make a Booking</Link></li>
                        </ul>
                    </nav>

                    <div className='off-canvas__bottom'>
                        <p>Royal Botanic Gardens Melbourne</p>
                        <p>Enter via Bridge Gate<br />Alexandra Avenue & Anderson Street</p>
                        <Link to={`mailto:info@theterrace.melbourne`}>info@theterrace.melbourne</Link>
                        <Link to={`tel:+61390876836`}>03 9087 6836</Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header